/**
 * PitchBook Admin API
 * PitchBook Admin OpenAPI specification
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {createAction} from '@reduxjs/toolkit';
import {ApiMethods, ConcurrentStrategies} from '@pb/middleware-api';
import {PayloadData} from '../types';
import type {BulkProgress} from '../models/BulkProgress';
import type {DischargeGrantsRequest} from '../models/DischargeGrantsRequest';
import type {DischargeGrantsResponse} from '../models/DischargeGrantsResponse';
import type {Error} from '../models/Error';

export interface BulkDischargeGrantsProgress$Request {
    id: string;
}

export interface BulkDischargeGrantsProgress$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const bulkDischargeGrantsProgressRequest = createAction<PayloadData<void, BulkDischargeGrantsProgress$Request>>('BULK_DISCHARGE_PRESET_GRANTS__BULK_DISCHARGE_GRANTS_PROGRESS__REQUEST');
export const bulkDischargeGrantsProgressSuccess = createAction<PayloadData<BulkProgress, BulkDischargeGrantsProgress$Request>>('BULK_DISCHARGE_PRESET_GRANTS__BULK_DISCHARGE_GRANTS_PROGRESS__SUCCESS');
export const bulkDischargeGrantsProgressFailure = createAction<PayloadData<Error, BulkDischargeGrantsProgress$Request, true>>('BULK_DISCHARGE_PRESET_GRANTS__BULK_DISCHARGE_GRANTS_PROGRESS__FAILURE');

export const bulkDischargeGrantsProgressActions = [
    bulkDischargeGrantsProgressRequest,
    bulkDischargeGrantsProgressSuccess,
    bulkDischargeGrantsProgressFailure
] as const;

/**
 * @param {string} meta.id Bulk operation id
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const bulkDischargeGrantsProgress = (meta: BulkDischargeGrantsProgress$Request, config?: BulkDischargeGrantsProgress$Config) => {
    const TRANSPORT_GET_PARAMS = {
        id: meta.id,
    };
    return {
        CALL_API: {
            types: bulkDischargeGrantsProgressActions,
            method: ApiMethods.GET,
            endpoint: `/web-api/bulk-actions/presets/discharge-grants/progress`,
            TRANSPORT_GET_PARAMS,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

export interface DischargeGrants$Request {
    dischargeGrantsRequest: DischargeGrantsRequest;
}

export interface DischargeGrants$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const dischargeGrantsRequest = createAction<PayloadData<void, DischargeGrants$Request>>('BULK_DISCHARGE_PRESET_GRANTS__DISCHARGE_GRANTS__REQUEST');
export const dischargeGrantsSuccess = createAction<PayloadData<string, DischargeGrants$Request>>('BULK_DISCHARGE_PRESET_GRANTS__DISCHARGE_GRANTS__SUCCESS');
export const dischargeGrantsFailure = createAction<PayloadData<Error, DischargeGrants$Request, true>>('BULK_DISCHARGE_PRESET_GRANTS__DISCHARGE_GRANTS__FAILURE');

export const dischargeGrantsActions = [
    dischargeGrantsRequest,
    dischargeGrantsSuccess,
    dischargeGrantsFailure
] as const;

/**
 * @param {DischargeGrantsRequest} meta.dischargeGrantsRequest
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const dischargeGrants = (meta: DischargeGrants$Request, config?: DischargeGrants$Config) => {
    return {
        CALL_API: {
            types: dischargeGrantsActions,
            method: ApiMethods.POST,
            endpoint: `/web-api/bulk-actions/presets/discharge-grants`,
            TRANSPORT_REQUEST_BODY: meta.dischargeGrantsRequest,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

export interface GetDischargeGrantsResult$Request {
    id: string;
}

export interface GetDischargeGrantsResult$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getDischargeGrantsResultRequest = createAction<PayloadData<void, GetDischargeGrantsResult$Request>>('BULK_DISCHARGE_PRESET_GRANTS__GET_DISCHARGE_GRANTS_RESULT__REQUEST');
export const getDischargeGrantsResultSuccess = createAction<PayloadData<DischargeGrantsResponse, GetDischargeGrantsResult$Request>>('BULK_DISCHARGE_PRESET_GRANTS__GET_DISCHARGE_GRANTS_RESULT__SUCCESS');
export const getDischargeGrantsResultFailure = createAction<PayloadData<Error, GetDischargeGrantsResult$Request, true>>('BULK_DISCHARGE_PRESET_GRANTS__GET_DISCHARGE_GRANTS_RESULT__FAILURE');

export const getDischargeGrantsResultActions = [
    getDischargeGrantsResultRequest,
    getDischargeGrantsResultSuccess,
    getDischargeGrantsResultFailure
] as const;

/**
 * @param {string} meta.id Bulk operation id
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getDischargeGrantsResult = (meta: GetDischargeGrantsResult$Request, config?: GetDischargeGrantsResult$Config) => {
    const TRANSPORT_GET_PARAMS = {
        id: meta.id,
    };
    return {
        CALL_API: {
            types: getDischargeGrantsResultActions,
            method: ApiMethods.GET,
            endpoint: `/web-api/bulk-actions/presets/discharge-grants`,
            TRANSPORT_GET_PARAMS,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

